module.exports = __webpack_public_path__ + "build/img/slimes_10.279b8664.png";